const categoryData = [
    {
        "SrNo": "1",
        "TypeofDocument": "Approval Note",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "2",
        "TypeofDocument": "Stock Exchange Intimation done before the issue",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": "Common for BSE & NSE"
    },
    {
        "SrNo": "2 a",
        "TypeofDocument": "Stock Exchange Intimation done before the issue - NSE proof",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "2 b",
        "TypeofDocument": "Stock Exchange Intimation done before the issue - BSE proof",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "3",
        "TypeofDocument": "Debenture Trustee Agreement",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "3 b",
        "TypeofDocument": "Debenture Trustee Consent",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "4",
        "TypeofDocument": "Information Memorandum",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "5",
        "TypeofDocument": "Allotment letter",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": "Common for NSE, BSE, NSDL, CDSL"
    },
    {
        "SrNo": "5 a",
        "TypeofDocument": "Allotment letter - NSE proof",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "5 b",
        "TypeofDocument": "Allotment letter - BSE proof",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "6",
        "TypeofDocument": "Master Creation Form - NSDL",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "6 a",
        "TypeofDocument": "Master Creation Form - CSDL",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "6 b",
        "TypeofDocument": "Master Creation Form - NSDL proof",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    },  
    {
        "SrNo": "6 c",
        "TypeofDocument": "Master Creation Form - CSDL proof",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "7",
        "TypeofDocument": "Corporate Action Form - NSDL",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "7 a",
        "TypeofDocument": "Corporate Action Form - CSDL",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "7 b",
        "TypeofDocument": "Corporate Action Form - NSDL proof",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "7 c",
        "TypeofDocument": "Corporate Action Form - CSDL proof",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "8",
        "TypeofDocument": "Simple Mortgate Deed",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "9",
        "TypeofDocument": "Deed of Hypothecation",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "10",
        "TypeofDocument": "Debenture Trust Deed",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "11",
        "TypeofDocument": "Credit Rating Letters",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": "Provision for Multiple uploads"
    },
    {
        "SrNo": "12",
        "TypeofDocument": "Pass-3",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "13",
        "TypeofDocument": "Pass-5",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "14",
        "TypeofDocument": "Allotment Confirmation (NSDL)",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "14 a",
        "TypeofDocument": "Allotment Confirmation (CSDL)",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "15",
        "TypeofDocument": "Listing Approval (BSE/NSE)",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": "Provision for Multiple uploads"
    },
    {
        "SrNo": "16",
        "TypeofDocument": "Intimation of Record Date and date of payment to NSE",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "16 a",
        "TypeofDocument": "Intimation of Record Date and date of payment to BSE",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "17",
        "TypeofDocument": "Payment Confirmation letter sent to NSE",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "17 a",
        "TypeofDocument": "Payment Confirmation letter sent to BSE",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "18",
        "TypeofDocument": "Redemption Corporate Action (NSDL)",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "18 a",
        "TypeofDocument": "Redemption Corporate Action (CSDL)",
        "Generated from System": "Yes",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "18 b",
        "TypeofDocument": "Redemption Corporate Action Confirmation (NSDL)",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    },
    {
        "SrNo": "18 c",
        "TypeofDocument": "Redemption Corporate Action Confirmation (CDSL)",
        "Generated from System": "No",
        "Upload Provision": "Yes",
        "Remarks": ""
    }
]


export default categoryData;